export default __webpack_public_path__ + "static/media/header_deco.6eaa2070.svg";